/**
 * @generated SignedSource<<df3041a47f3d3d84a4c15487e651d19e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionStatusCircleInline_RoutineOccasion$data = {
  readonly deadlineAt: string | null;
  readonly id: string;
  readonly routine: {
    readonly id: string;
    readonly title: string;
  };
  readonly startAt: string;
  readonly status: RoutineOccasionStatus;
  readonly " $fragmentType": "RoutineOccasionStatusCircleInline_RoutineOccasion";
};
export type RoutineOccasionStatusCircleInline_RoutineOccasion$key = {
  readonly " $data"?: RoutineOccasionStatusCircleInline_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircleInline_RoutineOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionStatusCircleInline_RoutineOccasion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "85bb31bee9746bc261aaf017c0f7ac21";

export default node;
